module.exports = __webpack_public_path__ + "c63a69e68f3190282e55858687d92125.png";